export const oneStarShop = {
  SG: 'https://onestar.oneclub.vip/',
  MY: 'https://onestar-my.oneclub.vip',
  HK: 'https://onestar-hk.oneclub.vip',
}

/**
 * 支持积分功能的国家地区码
 */
export const oneStarCountryCode = Object.keys(oneStarShop)

export const creditTypes = [
  { value: 'recharge', label: 'creditType.recharge' },
  { value: 'invite_register', label: 'creditType.invite_register' },
  { value: 'credit_redemption', label: 'creditType.credit_redemption' },
  { value: 'other', label: 'common.other' },
]

export const changeTypes = [
  { value: 'ADD', label: 'onestar.changeType.add' },
  { value: 'SUB', label: 'onestar.changeType.sub' },
]
